<div class="container">
  <button
    mat-icon-button
    color="primary"
    class="arrow-button"
    [disabled]="!isAbleToSelectPrevious()"
    (click)="previous()"
  >
    <mat-icon>arrow_back_ios</mat-icon>
  </button>

  <button
    mat-stroked-button
    color="primary"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [disabled]="isDisable()"
    (click)="isOpenCalendarPicker = true"
  >
    {{ formGroup.value | calendarDateRangeFormatter }}
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpenCalendarPicker"
    [cdkConnectedOverlayHasBackdrop]="true"
    (overlayOutsideClick)="isOpenCalendarPicker = false"
    [cdkConnectedOverlayPositions]="[]"
  >
    <lib-base-card class="calendar-picker-card">
      <mat-calendar
        [startView]="
          getCurrentViewMode() === CALENDAR_VIEW_MODE.MONTH ? 'year' : 'month'
        "
        [selected]="getSelectedDateForCalendarPicker()"
        [startAt]="getCurrentFromDate()"
        [minDate]="minDate"
        [maxDate]="maxDate"
        (monthSelected)="selectMonthAndCloseCalendarPicker($event)"
        (selectedChange)="selectDateAndCloseCalendarPicker($event)"
      ></mat-calendar>
      <div class="calendar-picker-button-wrapper">
        <button
          mat-flat-button
          color="primary"
          (click)="selectCurrentDateAndCloseCalendarPicker()"
        >
          {{
            'lib_calendar.date-picker.current.' + getCurrentViewMode()
              | translate
          }}
        </button>
      </div>
    </lib-base-card>
  </ng-template>

  <button
    mat-icon-button
    color="primary"
    class="arrow-button"
    [disabled]="!isAbleToSelectNext()"
    (click)="next()"
  >
    <mat-icon>arrow_forward_ios</mat-icon>
  </button>
</div>
